<template>
  <el-container class="header">
    <el-row>
      <el-col class="logo">
        <router-link to="/index"><img class="menu_bar_customer_logo_image" v-bind:src="logoImage"></router-link>
      </el-col>
      <slot></slot>
    </el-row>
  </el-container>
</template>
<script>
export default {
  data () {
    return {
      logoImage: require(process.env.VUE_APP_LOGO_FILE_PATH)
    }
  },
  mounted () {
    this.$nextTick(() => {
      const header = this.$el.closest('header')
      const headerRect = header.getBoundingClientRect()
      const body = header.closest('body')
      body.style.setProperty('--header-height', headerRect.height + 'px')
    })
  }
}
</script>

<style lang="scss">
section.header {
  font-size: 120%;
  height: 100%;
  background-color: var(--background-color);
  >.el-row {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    div.logo {
      flex-grow: 0;
      width: 13em;
      height: inherit;
      a {
        height: inherit;
        .menu_bar_customer_logo_image {
          // width: inherit;
          width: 100%;
          height: inherit;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
